import Swiper from 'swiper';

export default function carouselMarket() {

    if (window.compositeProductId > 0) {
        pushProductIdInStorage();
    }

    function pushProductIdInStorage(index) {

        let recentProducts = window.compositeProductId,
            arrayProducts;
        if (localStorage.getItem("recentProducts") === null)  {
            arrayProducts = [];
        }else {
            arrayProducts = JSON.parse(localStorage.getItem("recentProducts"));
        }

        let arrayExistProduct = (arrayProducts.indexOf(recentProducts) > -1);
        if (!arrayExistProduct) {
            arrayProducts.push(recentProducts);
            localStorage.setItem("recentProducts",JSON.stringify(arrayProducts));
        }

        $.ajax({
            type: "GET",
            dataType: "json",
            url: `/api/market/products/${arrayProducts}?locale=${window.langDefault}`,
            success: function(data, url) {
                $.each(data, function (i, item) {
                    let cartSlide = `
                    <div class="swiper-slide">
                        <div class="market-slide  ${ item.is_exclusive ? 'market-slide--exclusive' : ''}">
                            <a class="link-overlay" href=${item.url}></a>
                            <div class="market-slide__wrap">
                                <div class="market-slide__image market-slide__image--new">
                                    <picture data-expand="1000">
                                        <img loading="lazy" class=" lazyloaded" data-src=${item.picture} alt=${item.title} title=${item.title} src=${item.picture}>
                                    </picture>
                                </div>
                                <div class="market-slide__content">
                                    <div class="market-slide__availability ${item.availabilityClass}">${item.availability}</div>
                                    <div class="market-slide__head">
                                        <h5 class="_c-text-h-5">${item.title}</h5>
                                    </div>
                                    ${item.is_exclusive ? `
                                        <div class="market-slide__exclusive market-slide__exclusive--mobile">
                                            <div class="market-slide__exclusive-img"></div>
                                            <div class="market-slide__exclusive-content">
                                                <div class="market-slide__exclusive-head">${translations!==undefined ? translations.market_product_exclusive : 'Ексклюзивний товар'}</div>
                                            </div>
                                        </div>
                                    ` : ''}
                                    <div class="market-slide__manufacturer _text-caption">${item.manufacturer}</div>
                                    <div class="market-slide__price" data-hint="data-hint">
                                        <div class="market-slide__price-pre">${translations!==undefined ? translations.market_product_price_from : 'від'}</div>
                                        <div class="market-slide__price-label">${item.price}</div>
                                        <div class="market-slide__price-curr">${translations!==undefined ? translations.market_product_price_currency : 'грн'}</div>
                                    </div>
                                    <div class="market-slide__label _text-caption"></div>
                                        ${item.is_exclusive ? `
                                            <div class="market-slide__exclusive">
                                                <div class="market-slide__exclusive-img"></div>
                                                <div class="market-slide__exclusive-content">
                                                    <div class="market-slide__exclusive-head">${translations!==undefined ? translations.market_product_exclusive : 'Ексклюзивний товар'}</div>
                                                    <div class="market-slide__exclusive-label">${translations!==undefined ? translations.market_product_exclusive_label : 'Його можна придбати лише у Бізон-Тех'}</div>
                                                </div>
                                            </div>
                                        ` : ''}
                                        
                                    </div>
                            </div>
                            <div class="market-slide__hidden-content">
                                <div class="market-slide__button">
                                    <a class="btn btn--size-48 btn--accent" href=${item.url}>
                                        <span class="btn-caption">${translations!==undefined ? translations.market_product_show_more : 'Детальніше'}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>`;


                    $('.carousel-wrap--recently-viewed .swiper-wrapper').append(cartSlide);

                });
            },
            error: function( error ) {
                console.log(error);
            },
            complete: function () {
                $('.swiper-container:not(".gallery-img, .gallery-thumbs, .vehicle-image, .vehicle-thumbs, [data-slider-testimonials], [data-widget-homeslider-slider]")').each(function(index, element) {

                    let $this = $(this),
                        $carousel = $this.parents('.carousel-wrap').find('.swiper-slide');

                    $this.addClass('instance-' + index);
                    $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
                    $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

                    if ($(this).hasClass('market-recently-viewed'))  {

                        let $slides = $('.swiper-slide', $(this));

                        if ($slides.length <= 4) {
                            $(this).toggleClass('_has-single-slide');
                        }

                        if (window.innerWidth <= 1024 && $slides.length > 3) {
                            $(this).removeClass('_has-single-slide');
                        }

                        if (window.innerWidth < 600 && $slides.length > 2) {
                            $(this).removeClass('_has-single-slide');
                        }

                        let mySwiper = new Swiper('.instance-' + index, {
                            speed: 500,
                            slidesPerView: 4,
                            resistanceRatio: 0,
                            navigation: {
                                nextEl: '.swiper-next-btn-' + index,
                                prevEl: '.swiper-prev-btn-' + index
                            },
                            breakpoints: {
                                1023: {
                                    slidesPerView: 3,
                                },
                                599: {
                                    slidesPerView: 2,
                                },
                            }
                        });
                    }
                });
            }
        });
    }

    $('.swiper-container:not(".gallery-img, .market-carousel.market-recently-viewed, .gallery-thumbs, .vehicle-image, .vehicle-thumbs, [data-slider-testimonials], [data-widget-homeslider-slider]")').each(function(index, element) {

        let $this = $(this),
            $carousel = $this.parents('.carousel-wrap').find('.swiper-slide');

        $this.addClass('instance-' + index);
        $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
        $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

        if ($(this).hasClass('market-carousel'))  {

            let $slides = $('.swiper-slide', $(this));

            if ($slides.length <= 4) {
                $(this).toggleClass('_has-single-slide');
            }

            if (window.innerWidth <= 1024 && $slides.length > 3) {
                $(this).removeClass('_has-single-slide');
            }

            if (window.innerWidth < 600 && $slides.length > 2) {
                $(this).removeClass('_has-single-slide');
            }

            let mySwiper = new Swiper('.instance-' + index, {
                speed: 500,
                // spaceBetween: 3,
                slidesPerView: 4,
                resistanceRatio: 0,
                navigation: {
                    nextEl: '.swiper-next-btn-' + index,
                    prevEl: '.swiper-prev-btn-' + index
                },
                // pagination: {
                //     el: '.swiper-pagination',
                //     type: 'progressbar',
                // },
                breakpoints: {
                    1023: {
                        slidesPerView: 3,
                    },
                    599: {
                        slidesPerView: 2,
                    },
                }
            });

            $(window).resize(function() {


            });
        }
    });
}